import { Badge, BadgeProps, Select } from "@mantine/core"
import { COUNTRY_OPTIONS, countryOf } from "./country-scope"

/** País de un registro (sin país = Perú): Perú en azul, Ecuador en amarillo, igual que en Bandejas y Activos */
export function CountryBadge({ country, size = "sm" }: { country?: string | null; size?: BadgeProps["size"] }) {
  const value = countryOf(country)
  return (
    <Badge color={value === "Ecuador" ? "yellow" : "blue"} variant="light" size={size}>
      {value}
    </Badge>
  )
}

/** Control del filtro nativo de la columna País de una DataTable ("" = sin filtro) */
export function CountryFilterSelect({ value, onChange }: { value?: string | null; onChange: (value: string) => void }) {
  return <Select comboboxProps={{ withinPortal: false }} clearable placeholder="Filtrar por país" data={COUNTRY_OPTIONS} value={value || null} onChange={(next) => onChange(next ?? "")} />
}
